"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _button = require("@design/ui/button");
var _dialog = require("@design/ui/dialog");
var _label = require("@design/ui/label");
var _select = require("@design/ui/select");
var _textarea = require("@design/ui/textarea");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _sentryReporter = require("../../utils/sentry-reporter");
var _toast = require("../../utils/toast");
var _log = require("../../utils/wopi/log");
var _wopiSession = require("../../utils/wopi/wopi-session");
var _WopiActionBar = require("./WopiActionBar");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var NOTE_HELPER_TEXT = "Add a clear note to help others understand better.";
var DEFAULT_NOTES_CHARACTER_LIMIT = 1000;
function resolveConfirmLabel(action, status, isExternalUser) {
  var actionLabel = (0, _WopiActionBar.resolveActionLabel)(action, status, isExternalUser);
  if (action.value === "Reject") return actionLabel;
  return "Add & ".concat(actionLabel);
}
function resolveSuccessMessage(action, status, isExternalUser) {
  if (action.value === "Reject") return "Agreement rejected.";
  return (0, _WopiActionBar.resolveActionLabel)(action, status, isExternalUser) === "Accept" ? "Agreement accepted." : "Agreement approved.";
}
var WorkflowNoteDialog = function WorkflowNoteDialog(_ref) {
  var _action$showReasonCod;
  var open = _ref.open,
    onOpenChange = _ref.onOpenChange,
    action = _ref.action,
    status = _ref.status,
    isExternalUser = _ref.isExternalUser,
    onConfirm = _ref.onConfirm;
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    note = _useState2[0],
    setNote = _useState2[1];
  var _useState3 = (0, _react.useState)(""),
    _useState4 = _slicedToArray(_useState3, 2),
    reasonCodeId = _useState4[0],
    setReasonCodeId = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    reasonCodes = _useState6[0],
    setReasonCodes = _useState6[1];
  var _useState7 = (0, _react.useState)(DEFAULT_NOTES_CHARACTER_LIMIT),
    _useState8 = _slicedToArray(_useState7, 2),
    characterLimit = _useState8[0],
    setCharacterLimit = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isSubmitting = _useState0[0],
    setIsSubmitting = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isConfirmingCloseWhileSaving = _useState10[0],
    setIsConfirmingCloseWhileSaving = _useState10[1];
  var currentSubmissionRef = (0, _react.useRef)(0);
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics.analytics;
  var showReasonCode = (_action$showReasonCod = action === null || action === void 0 ? void 0 : action.showReasonCode) !== null && _action$showReasonCod !== void 0 ? _action$showReasonCod : false;
  (0, _react.useEffect)(function () {
    if (!open) return;
    setNote("");
    setReasonCodeId("");
    var cancelled = false;
    void _wopiSession.wopiSession.getNotesCharacterLimit().then(function (limit) {
      if (!cancelled) setCharacterLimit(limit);
    });
    if (showReasonCode) {
      _wopiSession.wopiSession.getReasonCodes().then(function (codes) {
        if (!cancelled) setReasonCodes(codes);
      }).catch(function (error) {
        return (0, _sentryReporter.reportError)(error, {
          level: "warning",
          extra: {
            component: "WorkflowNoteDialog",
            action: "get_reason_codes"
          }
        });
      });
    } else {
      setReasonCodes([]);
    }
    return function () {
      cancelled = true;
    };
  }, [open, showReasonCode]);
  if (!action) return null;
  var noteValid = note.length <= characterLimit && (!action.isNoteMandatory || note.trim().length > 0);
  var reasonValid = !showReasonCode || !action.isReasonCodeMandatory || reasonCodeId !== "";
  var canConfirm = !isSubmitting && noteValid && reasonValid;
  function handleConfirm(_x) {
    return _handleConfirm.apply(this, arguments);
  }
  function _handleConfirm() {
    _handleConfirm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
      var submission, isCurrentSubmission, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            event.preventDefault();
            if (!(!action || !canConfirm)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            (0, _log.wlog)("note dialog: confirm ".concat(action.value, " (note len=").concat(note.trim().length, ", reasonCodeId=").concat(reasonCodeId || "none", ")"));
            setIsSubmitting(true);
            submission = ++currentSubmissionRef.current;
            isCurrentSubmission = function isCurrentSubmission() {
              return submission === currentSubmissionRef.current;
            };
            _context.p = 2;
            _context.n = 3;
            return onConfirm(note.trim(), reasonCodeId || undefined);
          case 3:
            (0, _toast.toastSuccess)(resolveSuccessMessage(action, status, isExternalUser));
            if (isCurrentSubmission()) onOpenChange(false);
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            (0, _log.wlog)("note dialog: submit failed → error toast", _t);
            (0, _sentryReporter.reportError)(_t, {
              extra: {
                component: "WorkflowNoteDialog",
                action: "submit_workflow_note",
                workflowAction: action.value
              }
            });
            (0, _toast.toastError)("Failed to submit your response. Please try again.");
          case 5:
            _context.p = 5;
            if (isCurrentSubmission()) {
              setIsSubmitting(false);
              setIsConfirmingCloseWhileSaving(false);
            }
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4, 5, 6]]);
    }));
    return _handleConfirm.apply(this, arguments);
  }
  function requestClose() {
    if (isSubmitting) setIsConfirmingCloseWhileSaving(true);else onOpenChange(false);
  }
  function closeWhileSaving() {
    analytics === null || analytics === void 0 || analytics.track("workflow_note_closed_while_saving", {
      workflowAction: action === null || action === void 0 ? void 0 : action.value
    });
    currentSubmissionRef.current += 1;
    setIsSubmitting(false);
    setIsConfirmingCloseWhileSaving(false);
    onOpenChange(false);
  }
  function keepWaitingForSave() {
    analytics === null || analytics === void 0 || analytics.track("workflow_note_save_awaited", {
      workflowAction: action === null || action === void 0 ? void 0 : action.value
    });
    setIsConfirmingCloseWhileSaving(false);
  }
  var reasonCodeField = showReasonCode ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_label.Label, {
      htmlFor: "reason-code",
      children: ["Reason code", action.isReasonCodeMandatory ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: "text-destructive",
        children: "*"
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_select.Select, {
      value: reasonCodeId,
      onValueChange: setReasonCodeId,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectTrigger, {
        id: "reason-code",
        className: "w-full",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectValue, {
          placeholder: "Select reason code"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectContent, {
        children: reasonCodes.map(function (code) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_select.SelectItem, {
            value: code.sysId,
            children: code.reason
          }, code.sysId);
        })
      })]
    })]
  }) : null;
  var noteField = /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-2",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_label.Label, {
      htmlFor: "workflow-note-description",
      children: "Description"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_textarea.Textarea, {
      id: "workflow-note-description",
      "data-autofocus": true,
      className: "min-h-30",
      placeholder: "Add note...",
      value: note,
      maxLength: characterLimit,
      onChange: function onChange(event) {
        return setNote(event.target.value);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center justify-between text-sm text-muted-foreground",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: NOTE_HELPER_TEXT
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        children: [note.length, "/", characterLimit]
      })]
    })]
  });
  var closeWhileSavingConfirmation = isConfirmingCloseWhileSaving ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
    tone: "destructive",
    title: "Your note is still saving",
    message: "If you close now and the save doesn't finish, your note will be lost.",
    confirmLabel: "Close anyway",
    cancelLabel: "Keep waiting",
    onCancel: keepWaitingForSave,
    onConfirm: closeWhileSaving
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.Dialog, {
    open: open,
    onOpenChange: function onOpenChange(nextOpen) {
      if (!nextOpen) requestClose();
    },
    "data-sentry-element": "Dialog",
    "data-sentry-component": "WorkflowNoteDialog",
    "data-sentry-source-file": "WorkflowNoteDialog.tsx",
    children: [closeWhileSavingConfirmation, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogContent, {
      "aria-describedby": undefined,
      "data-sentry-element": "DialogContent",
      "data-sentry-source-file": "WorkflowNoteDialog.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogHeader, {
        "data-sentry-element": "DialogHeader",
        "data-sentry-source-file": "WorkflowNoteDialog.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dialog.DialogTitle, {
          "data-sentry-element": "DialogTitle",
          "data-sentry-source-file": "WorkflowNoteDialog.tsx",
          children: "Add note"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleConfirm,
        className: "contents",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex flex-col gap-4",
          children: [noteField, reasonCodeField]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dialog.DialogFooter, {
          "data-sentry-element": "DialogFooter",
          "data-sentry-source-file": "WorkflowNoteDialog.tsx",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "button",
            variant: "outline",
            onClick: requestClose,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "WorkflowNoteDialog.tsx",
            children: "Cancel"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
            type: "submit",
            disabled: !canConfirm,
            "data-sentry-element": "Button",
            "data-sentry-source-file": "WorkflowNoteDialog.tsx",
            children: isSubmitting ? "Submitting..." : resolveConfirmLabel(action, status, isExternalUser)
          })]
        })]
      })]
    })]
  });
};
var _default = exports.default = WorkflowNoteDialog;